export default __webpack_public_path__ + "static/media/led2_stop.de70871d.svg";